import React from 'react';
import Reflux from 'reflux';
import Header from '../sections/Header';
import NewTopic from '../sections/NewTopic';
import Footer from '../sections/Footer';

class NewTopicPage extends Reflux.Component {
    render () {
        return <div>
          <Header />
          <NewTopic />
          <Footer />
        </div>;
    }
}

export default NewTopicPage;



// WEBPACK FOOTER //
// ./src/pages/NewTopicPage.js